import { useEffect, useState } from "react";
import { useSocket } from "../provider/SocketProvider";

const normalizeMarket = (market, marketId) => {
  let exchangePayload =
    market?.payload?.payload?.runners ||
    market?.payload?.runners ||
    market?.runners;

  const fancyCatalogue =
    market?.data?.catalogue || market?.payload?.catalogue || market?.catalogue;

  // detect fancy live update
  const fancyPayload =
    market?.payload &&
    market?.payload?.id &&
    (market?.payload?.back || market?.payload?.lay)
      ? market.payload
      : null;
  // FANCY LIVE UPDATE
  if (fancyPayload) {
    return {
      marketId: market?.marketId ?? marketId,
      type: "fancy",

      marketStatus: market?.marketStatus,

      runners: [
        {
          id: fancyPayload.id,
          status: fancyPayload.status,

          back: fancyPayload.back
            ? Array.isArray(fancyPayload.back)
              ? fancyPayload.back
              : [fancyPayload.back]
            : [],

          lay: fancyPayload.lay
            ? Array.isArray(fancyPayload.lay)
              ? fancyPayload.lay
              : [fancyPayload.lay]
            : [],
        },
      ],
    };
  }
  if (
    !exchangePayload &&
    !fancyCatalogue &&
    typeof market === "object" &&
    market !== null
  ) {
    const values = Object.values(market);

    const hasRunners =
      values.length > 0 &&
      values.some(
        (v) => v && typeof v === "object" && v.id && (v.back || v.lay),
      );

    if (hasRunners) {
      exchangePayload = values.filter(
        (v) => v && typeof v === "object" && v.id,
      );
    }
  }

  // EXCHANGE
  if (exchangePayload) {
    return {
      marketId: market?.marketId ?? marketId,
      type: "exchange",

      status: market?.payload?.status ?? market?.status,

      runners: exchangePayload.map((runner) => ({
        id: runner.id,
        status: runner.status,

        back: runner.back
          ? Array.isArray(runner.back)
            ? runner.back
            : [runner.back]
          : [],

        lay: runner.lay
          ? Array.isArray(runner.lay)
            ? runner.lay
            : [runner.lay]
          : [],
      })),
    };
  }

  // FANCY SNAPSHOT
  if (fancyCatalogue) {
    return {
      marketId: market?.marketId ?? marketId,
      type: "fancy",

      status: fancyCatalogue.status,

      minBet: fancyCatalogue.marketCondition?.minBet,
      maxBet: fancyCatalogue.marketCondition?.maxBet,

      runners: fancyCatalogue.runners.map((runner) => ({
        id: runner.id,
        name: runner.name,
      })),
    };
  }

  return null;
};

const useMarketDetailsSocket = (marketIds = []) => {
  console.log("🚀 ~ useMarketDetailsSocket ~ marketIds:", marketIds);
  const { socket, isConnected } = useSocket();

  const [markets, setMarkets] = useState({});

  useEffect(() => {
    if (!socket || !isConnected || !marketIds.length) return;

    marketIds.forEach((marketId) => {
      socket.emit("subscribe_markets", marketId);
    });

    // SNAPSHOT
    const handleSubscribedMarkets = (data) => {
      console.log("Subscribeddata", data);
      if (!data?.snapshot) return;

      const normalizedMarkets = {};

      Object.entries(data.snapshot).forEach(([marketId, market]) => {
        const normalized = normalizeMarket(market, marketId);
        if (normalized) {
          normalizedMarkets[marketId] = normalized;
        }
      });

      setMarkets((prev) => ({
        ...prev,
        ...normalizedMarkets,
      }));
    };

    // LIVE UPDATE
    const handleMarketUpdate = (data) => {
      console.log("MarketUpdatedata", data);
      if (!data?.marketId) return;
      const normalized = normalizeMarket(data?.payload ?? data, data.marketId);
      if (!normalized) return;
      setMarkets((prev) => {
        if (
          JSON.stringify(prev[data.marketId]) === JSON.stringify(normalized)
        ) {
          return prev;
        }
        return {
          ...prev,
          [data.marketId]: normalized,
        };
      });
    };
    socket.on("subscribed_markets", handleSubscribedMarkets);
    socket.on("market_update", handleMarketUpdate);

    return () => {
      socket.off("subscribed_markets", handleSubscribedMarkets);
      socket.off("market_update", handleMarketUpdate);
      marketIds.forEach((marketId) => {
        socket.emit("unsubscribe_markets", marketId);
      });
    };
  }, [socket, isConnected, marketIds]);

  return markets;
};

export default useMarketDetailsSocket;
